import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { EnvService } from 'src/app/_services/env.service';
import { RequestService } from 'src/app/_services/request.service';

@Component({
  selector: 'app-redirect-pengaduan',
  templateUrl: './redirect-pengaduan.component.html',
  styleUrls: ['./redirect-pengaduan.component.scss'],
})
export class RedirectPengaduanComponent implements OnInit {

  ticket: any;
  aduanId:any;

  constructor(
    private route: ActivatedRoute,
    private env:EnvService,
    private req: RequestService,
    private navCtrl: NavController,
  ) {
    this.ticket = this.route.snapshot.paramMap.get('ticket');
  }

  ngOnInit() {
    this.getPengaduanByTicket(this.ticket);
  }

  async getPengaduanByTicket(ticket) {
    this.navCtrl.navigateForward(['/detail-public', ticket]);
  }

}
